import { usePrograms } from "frontend/src/domain/programs";
import { useCreateProgram } from "frontend/src/domain/programs/actions";
export var usePageModel = function () {
    return usePrograms();
};
export var useCreateNewProgram = function () {
    var _a = useCreateProgram(), run = _a.run, data = _a.data, isSuccess = _a.isSuccess, isLoading = _a.isLoading;
    var create = function () { return run({ title: "Новая программа", entries: [] }); };
    return { create: create, isLoading: isLoading, data: data, isSuccess: isSuccess };
};
